import React from 'react';
import { useLink } from '@xingternal/hub';
export function Link({ children, to, ...props }) {
    const Link = useLink();
    if (to) {
        return (React.createElement(Link, { to: to, ...props }, children));
    }
    else {
        return React.createElement("a", { ...props }, children);
    }
}
//# sourceMappingURL=index.js.map